export default __webpack_public_path__ + "static/media/fromMarket.5210e442.svg";